import React, { Component } from "react";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../../res/iconos/logoNav.svg";
import { ReactComponent as IcoMenu } from "../../../res/iconos/menu.svg";
import Menu from "./menu.jsx";
import { CSSTransition } from "react-transition-group";

function withRouterAndNavigate(Component) {
  function ComponentWithRouterAndNavigate(props) {
    let params = useParams();
    let navigate = useNavigate();
    let location = useLocation();
    return (
      <Component
        {...props}
        params={params}
        navigate={navigate}
        location={location}
      />
    );
  }
  return ComponentWithRouterAndNavigate;
}

class NavBar extends Component {
  state = { mostrarMenu: false, nivelLogin: this.props.nivelLogin };

  componentDidUpdate(prevProps) {
    if (prevProps.nivelLogin != this.props.nivelLogin) {
      this.setState({ nivelLogin: this.props.nivelLogin });
    }
  }

  ocultarMenu() {
    this.setState({ mostrarMenu: false });
  }

  render() {
    const mobile = window.innerWidth < 1280;
    
    const paths = this.props.location.pathname.split("/");
    const pathHome = paths.slice(0,2).join("/") + "/home";

    return (
      <div
        style={{
          width: "100%",
          top: 0,
          position: (this.state.mostrarMenu && mobile)?"sticky":undefined,
          background: "transparent",
          height: 150,
          zIndex: 100,
        }}
      >
        <div style={mobile?{height: "100%"}:{paddingLeft: "10%", paddingRight: "10%", height: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "27%"}}>
          <Link
            to={pathHome}
            onClick={() => {
              this.setState({ mostrarMenu: false });
            }}
          >
            <Logo style={mobile?{height: "100%", width: 257, display: "inline", marginLeft: "10%"}:undefined} width={257} height={82} />
          </Link>
          {mobile && (
            <React.Fragment>
              <div
                onClick={() => {
                  this.setState({ mostrarMenu: !this.state.mostrarMenu });
                }}
                style={{
                  display: "flex",
                  float: "right",
                  marginRight: "10%",
                  height: "100%",
                  position: "relative"
                }}
              >
                <IcoMenu
                  width={35}
                />
              </div>
              <CSSTransition
                in={this.state.mostrarMenu}
                timeout={100}
                classNames="opacidad"
                unmountOnExit
              >
                <Menu
                  mobile={mobile}
                  ocultar={this.ocultarMenu.bind(this)}
                  nivelLogin={this.state.nivelLogin}
                  botones={this.props.botones}
                />
              </CSSTransition>
            </React.Fragment>
          )}
          {!mobile && (
            <Menu
              mobile={mobile}
              ocultar={this.ocultarMenu.bind(this)}
              nivelLogin={this.state.nivelLogin}
              botones={this.props.botones}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withRouterAndNavigate(NavBar);
